import { render, staticRenderFns } from "./MediaItem.vue?vue&type=template&id=98336a86&scoped=true"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"
import style0 from "./MediaItem.vue?vue&type=style&index=0&id=98336a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98336a86",
  null
  
)

export default component.exports